import { useTheme } from '../context/ThemeContext'

function DarkModeToggle() {
  const { darkMode, toggleDarkMode } = useTheme()

  return (
    <button
      onClick={toggleDarkMode}
      style={{
        background: darkMode ? '#f1f5f9' : '#1e293b',
        color: darkMode ? '#1e293b' : '#f1f5f9',
        border: 'none',
        padding: '10px 15px',
        borderRadius: 25,
        cursor: 'pointer',
        fontSize: 14,
        display: 'flex',
        alignItems: 'center',
        gap: 8,
        transition: 'all 0.3s ease'
      }}
    >
      {darkMode ? '☀️ Light Mode' : '🌙 Dark Mode'}
    </button>
  )
}

export default DarkModeToggle